type NameMap = {
  [key: string]: string;
};

export const tranfer_bank_to_hotel = new Map([
  ["Chase Ultimate Rewards", ["marriott", "ihg", "hyatt"]],
  ["American Exp Membership Rewards", ["marriott", "hilton", "choice"]],
  ["Capital One Miles Rewards", ["accor", "wyndam", "choice"]],
  ["Bilt Rewards", ["ihg", "hyatt"]],
  ["Citi Thank You Points", ["wyndham", "choice", "accor"]],
]);

export const HOTEL_NAME: NameMap = {
  marriott: "Marriott Bonvoy",
  ihg: "IHG One Rewards",
  hyatt: "World of Hyatt",
  hilton: "Hilton Honors",
};

export const HOTEL_IMG: NameMap = {
  marriott: "https://img.awardtool-api.com/hotel-imgs/marriott-min.png",
  ihg: "https://img.awardtool-api.com/hotel-imgs/ihg-min.png",
  hyatt: "https://img.awardtool-api.com/hotel-imgs/hyatt-min.png",
  hilton: "https://img.awardtool-api.com/hotel-imgs/hilton-min.png",
};
